module.exports = __webpack_public_path__ + "static/media/5612-logo-edited.76bba72f.png";